import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { AiOutlineCheck, AiOutlineClose } from 'react-icons/ai';
import '../styles/notification.css';

const Notification = ({ message, isVisible, onClose, actionText, onActionClick, duration = 3000 }) => {
  const navigate = useNavigate();

  useEffect(() => {
    let timer;
    if (isVisible) {
      timer = setTimeout(() => {
        onClose();
      }, duration);
    }
    return () => {
      if (timer) {
        clearTimeout(timer);
      }
    };
  }, [isVisible, onClose, duration]);

  const navigateToCart = (e) => {
    e.stopPropagation();
    navigate('/cart');
    onClose();
  };

  const navigateToWishlist = (e) => {
    e.stopPropagation();
    navigate('/myaccount#wishlist');
    onClose();
  };

  const handleClose = (e) => {
    e.stopPropagation();
    onClose();
  };

  if (!isVisible) return null;

  return (
    <div className="notification-container" onClick={e => e.stopPropagation()}>
      <div className="notification-content">
        <div className="notification-icon">
          <AiOutlineCheck className="success-icon" />
        </div>
        <p className="notification-message">{message}</p>
        <div className="notification-actions">
          {actionText && (
            <button 
              className="notification-action-button" 
              onClick={actionText.toLowerCase().includes('cart') ? navigateToCart : navigateToWishlist}
            >
              {actionText}
            </button>
          )}
          <button 
            className="notification-close" 
            onClick={handleClose}
          >
            <AiOutlineClose />
          </button>
        </div>
      </div>
    </div>
  );
};

export default Notification; 